import defaultAsapSelfDeliveryOrder from './standard/defaultAsapSelfDeliveryOrder.json';
import cashAsapSelfDeliveryOrder from './standard/cashAsapSelfDeliveryOrder.json';
import cashAsapPickupOrder from './standard/cashAsapPickupOrder.json';
import newDefaultAsapSelfDeliveryOrder from './standard/newDefaultAsapSelfDeliveryOrder.json';
import newDefaultAsapGHDeliveryOrder from './standard/newDefaultAsapGHDeliveryOrder.json';
import vanillaAsapSelfDeliveryOrder from './standard/vanillaAsapSelfDeliveryOrder.json';
import vanillaAsapPickupOrder from './standard/vanillaAsapPickupOrder.json';
import vanillaAsapGhDirectPickupOrder from './standard/vanillaAsapGhDirectPickupOrder.json';
import cancelledAsapSelfDeliveryOrder from './standard/cancelledAsapSelfDeliveryOrder.json';
import anticipatedFuturePickupOrder from './standard/anticipatedFuturePickupOrder.json';
import adjustedAsapGHDOrder from './standard/adjustedAsapGHDOrder.json';
import adjustedAsapSelfDeliveryOrder from './standard/adjustedAsapSelfDeliveryOrder.json';
import confirmedFutureMockOrder from './standard/confirmedFutureSelfDeliveryOrder.json';
import unconfirmedFuturePickupOrder from './standard/unconfirmedFuturePickupOrder.json';
import redactedAsapSelfDeliveryOrder from './standard/redactedAsapSelfDeliveryOrder.json';
import redactedAsapGHDOrder from './standard/redactedAsapGHDOrder.json';
import seamlessDefaultASAPDeliveryOrder from './standard/seamlessDefaultASAPDeliveryOrder.json';
import eat24DefaultASAPDeliveryOrder from './standard/eat24DefaultASAPDeliveryOrder.json'
import cateringAsapGHDOrder from './catering/cateringAsapGHDOrder.json';
import cateringFutureGHDOrder from './catering/cateringFutureGHDOrder.json';
import cateringFutureGHDNoLineInfoOrder from './catering/cateringFutureGHDNoLineInfoOrder.json';
import groupOrder from './group/groupOrder.json';
import groupOrderGhd from './group/groupOrderGhd.json';
import groupAllActiveOrder from './group/groupAllActiveOrder.json';
import groupAdjustedOrder from './group/groupAdjustedOrder.json';
import groupCancelledSomeDiners from './group/groupCancelledSomeDiners.json';
import groupCancelledOrder from './group/groupCancelledOrder.json';
import oneItemAsapSelfDeliveryOrder from './standard/oneItemAsapSelfDeliveryOrder.json';
import ghdAsPickup from './standard/ghdAsPickup.json';
import singleCartTaxExemptedOrder from './standard/singleCartTaxExemptedOrder.json';
import singleCartTaxExemptedOrderCorpLoc from './standard/singleCartTaxExemptedOrderWithCorpLocPayment.json';
import singleCartNonTaxExemptedOrder from './standard/singleCartNonTaxExemptedOrder.json';
import wonderDefaultASAPDeliveryOrder from './standard/wonderDefaultASAPDeliveryOrder.json';
import multiCartTaxExemptedOrder from './group/multiCartTaxExemptedOrder.json';
import multiCartTaxExemptedOrderCorpLoc from './group/multiCartTaxExemptedOrderWithCorpLocPayment.json';
import multiCartNonTaxExemptedOrder from './group/multiCartNonTaxExemptedOrder.json';

const merchantPhoneNumber =  "(133) 555-7890";
const useDmpFields =  true;

// Pickup order
export {
    multiCartNonTaxExemptedOrder,
    multiCartTaxExemptedOrder,
    multiCartTaxExemptedOrderCorpLoc,
    singleCartTaxExemptedOrder,
    singleCartTaxExemptedOrderCorpLoc,
    singleCartNonTaxExemptedOrder,
    defaultAsapSelfDeliveryOrder,
    cashAsapSelfDeliveryOrder,
    cashAsapPickupOrder,
    newDefaultAsapSelfDeliveryOrder,
    newDefaultAsapGHDeliveryOrder,
    vanillaAsapSelfDeliveryOrder,
    vanillaAsapPickupOrder,
    vanillaAsapGhDirectPickupOrder,
    cancelledAsapSelfDeliveryOrder,
    anticipatedFuturePickupOrder,
    adjustedAsapGHDOrder,
    adjustedAsapSelfDeliveryOrder,
    confirmedFutureMockOrder,
    unconfirmedFuturePickupOrder,
    redactedAsapSelfDeliveryOrder,
    redactedAsapGHDOrder,
    cateringAsapGHDOrder,
    cateringFutureGHDOrder,
    cateringFutureGHDNoLineInfoOrder,
    groupOrder,
    groupOrderGhd,
    groupAllActiveOrder,
    groupAdjustedOrder,
    groupCancelledSomeDiners,
    groupCancelledOrder,
    oneItemAsapSelfDeliveryOrder,
    seamlessDefaultASAPDeliveryOrder,
    eat24DefaultASAPDeliveryOrder,
    wonderDefaultASAPDeliveryOrder,
    merchantPhoneNumber,
    ghdAsPickup,
    useDmpFields
};




// WEBPACK FOOTER //
// ./client/app/util/mock_orders.js